import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import FormInput from '../../../../../components/form/FormInput';
import { hideModal } from '../../../../../redux/modules/modal';
import { globalRequirementTemplateBuilder } from '../../../../../redux/reducer';
import {inAppText} from "../../../../../constants/inAppText";

function DraftDetailsModal({ templateId }) {
  const dispatch = useDispatch();
  const useFormMethods = useForm();
  const { handleSubmit, reset } = useFormMethods;

  useEffect(() => {
    dispatch(globalRequirementTemplateBuilder.getRequirementTemplate(templateId));

    return () => dispatch(globalRequirementTemplateBuilder.resetSelectedTemplate());
  }, []);

  const template = useSelector(globalRequirementTemplateBuilder.selectCurrentRequirementTemplate);

  useEffect(() => {
    if (template) {
      const defaultValues = { name: template.name, description: template.description };
      reset(defaultValues);
    }
  }, [template]);

  const onSubmit = async data => {
    await dispatch(globalRequirementTemplateBuilder.updateRequirementTemplate(template.id, {
      name: data.name,
      description: data.description
    }));

    dispatch(globalRequirementTemplateBuilder.listDraftedRequirementTemplates());
    dispatch(hideModal());
  };

  return (
    <form id="draftDetails" onSubmit={handleSubmit(onSubmit)}>
      <FormInput
        required
        inputName="name"
        labelName="Template Name"
        placeholder="Template Name"
        useFormMethods={useFormMethods}
      />
      <FormInput
        inputName="description"
        labelName="Template Description"
        placeholder="Type your template description here"
        toolTip={inAppText.tooltips.templates.drafts.draftOptions.draftDetails}
        type="textArea"
        useFormMethods={useFormMethods}
        validationRules={{
          maxLength: { value: 280, message: 'Template Description have fewer than 280 characters' }
        }}
      />
    </form>
  );
}

export default DraftDetailsModal;
